// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerLinkListStyles } from "@ces/Overrides/Widgets/Header/HeaderLinkList";
import ArrowDown from "@ces/XDL/Icons/ArrowDown";
import { childrenSelector } from "@ces/XDL/PreStyle/link";
import { color, styledScrollbar } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        gap: 15px;
        align-items: center;
        & > div {
            display: inline-flex;
            & > span {
                display: inline-flex;
            }
            &:not(:last-child) {
                border-right: 1px solid ${color("common.white")};
                padding-right: 18px;
            }
        }
        &&& {
            ${IconWrapper} {
                opacity: 1;
            }
        }
    `,
};

headerLinkListStyles.menuLink = {
    color: "common.white",
    icon: {
        iconProps: {
            src: ArrowDown,
            color: "common.white",
            css: css`
                width: 9px;
                height: 13px;
            `,
        },
        position: "right",
    },
    typographyProps: {
        css: css`
            &&& {
                line-height: 13px;
            }
        `,
    },
    css: css`
        transition: all ease-in-out 300ms;
        padding: 1px 0;
        gap: 9px;
        &[aria-expanded="true"] {
            ${IconWrapper} {
                rotate: 180deg;
            }
        }

        &:not(:disabled):visited {
            ${childrenSelector} {
                color: ${color("common.white")};
            }
        }

        &:not([disabled]):hover,
        &:not([disabled]):focus {
            ${childrenSelector}, ${IconWrapper} svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

headerLinkListStyles.link = {
    color: "common.white",
    typographyProps: {
        color: "common.white",
        size: 12,
        css: css`
            &&& {
                line-height: 13px;
            }
        `,
    },
    css: css`
        padding: 1px 0;

        &:not([disabled]):visited {
            ${childrenSelector}, ${IconWrapper} svg {
                color: ${color("common.white")};
            }
        }
    `,
};

headerLinkListStyles.menuContent = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        color: ${color("common.black")};
        padding: 16px;
        max-height: 50vh;
        overflow: auto;
        ${styledScrollbar()}
    `,
};
